import { render, staticRenderFns } from "./Whens.vue?vue&type=template&id=88bc7e10&scoped=true&"
import script from "./Whens.vue?vue&type=script&lang=js&"
export * from "./Whens.vue?vue&type=script&lang=js&"
import style0 from "./Whens.vue?vue&type=style&index=0&id=88bc7e10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bc7e10",
  null
  
)

export default component.exports